import useApiRecord from "hooks/use_api_record"

const useCheckInsSignupIntegration = (eventId, data = {}) => {
  const path = `/events/${eventId}/check_ins_signup_integration`
  const defaultData = {
    fields: { SignupIntegration: "id,integration_id,app,signup_label_options" }
  }
  const { loading, errors, resource, record } = useApiRecord({
    id: null,
    path,
    data: { ...defaultData, ...data },
    singular: true
  })

  const create = () => {
    if (record) return Promise.resolve(record)
    return resource.create({ app: "check_ins" })
  }

  return {
    loading,
    errors,
    record: { ...record, create }
  }
}

export default useCheckInsSignupIntegration
